import { useCallback } from 'react';
import { useDispatch } from 'store/hooks';
import { createUpdateWidgetComponentStateAction } from './actions';
import { useWidgetContext } from 'widgets/WidgetContext';

export const useDispatchUpdateWidgetComponentState = <T>() => {
    const { widgetType, widgetKey } = useWidgetContext();
    const dispatch = useDispatch();
    const updateWidgetComponentStateAction =
        createUpdateWidgetComponentStateAction<T>(widgetType);
    return useCallback(
        (configDelta: Partial<T>) =>
            dispatch(updateWidgetComponentStateAction(widgetKey, configDelta)),
        [dispatch, updateWidgetComponentStateAction, widgetKey]
    );
};
